import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { FlexColumn, FlexRow } from "@similarweb/ui-components";

export const StyledQuickLoadingCard = styled(FlexRow)`
    border-radius: 6px;
    border: 1px solid ${colorsPalettes.blue[200]};
    background: ${colorsPalettes.carbon[0]};
    width: 265px;
    padding: 12px;
    gap: 12px;
`;

export const StyledCardContent = styled(FlexColumn)`
    gap: 8px;
`;
